/*!
 * CollectionMenus.js
 */
"use strict";

(function (CollectionMenus, $) {
  'use strict';

  var $dom = {};

  var cacheDom = function cacheDom() {
    $dom.jsSelectMenu = $('.js-select-menu');
    $dom.jsSelectMenuLabel = $('.js-select-menu-label');
    $dom.jsSelectLinksMenu = $('.js-select-links-menu');
  };

  var shopifySort = function shopifySort() {
    Shopify.queryParams = {};

    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');

        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    $('#collection--sort-by').val('{{ collection.sort_by | default: collection.default_sort_by | escape }}').bind('change', function () {
      Shopify.queryParams.sort_by = $(this).val();
      location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
    });
  };

  var mobileSelectMenuUpdateLabel = function mobileSelectMenuUpdateLabel() {
    var searchQuery = window.location.search;
    var sortQuery = searchQuery.split('sort_by=')[1];

    if (typeof sortQuery != 'undefined' && sortQuery != '') {
      if (sortQuery.indexOf('&') > -1) {
        sortQuery = sortQuery.split('&')[0];
      }

      var $sortOptionSelected = $(".js-select-menu option[value=\"".concat(sortQuery, "\"]"));
      var sortLabelText = $sortOptionSelected.text();
      $dom.jsSelectMenuLabel.text(sortLabelText);
      $dom.jsSelectMenu.val(sortQuery);
    } else {
      return false;
    }
  };

  var mobileSelectLinksMenu = function mobileSelectLinksMenu(select) {
    var selectValue = $(select).val();

    if (selectValue != '') {
      window.location = selectValue;
    }
  };

  var bindUIActions = function bindUIActions() {
    shopifySort();
    $dom.jsSelectMenu.on('change', function (event) {
      mobileSelectMenu(this);
    });
    $(document).ready(function () {
      mobileSelectMenuUpdateLabel();
    });
    $dom.jsSelectLinksMenu.on('change', function (event) {
      mobileSelectLinksMenu(this);
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  CollectionMenus.init = init;
})(window.CollectionMenus = window.CollectionMenus || {}, jQuery);

/*!
 * HeaderNavigation.js
 */
"use strict";

(function (HeaderNavigation, $) {
  'use strict';

  var menuCloseTimer; // keep track of setTimeout()

  var hideMenuDelay = 200; // milliseconds

  var activeMenu; // keep track of active drop-down menu

  var $dom = {};

  var cacheDom = function cacheDom() {
    $dom.mainNavTopLevelLink = $('.nav-link-drop-down-toggle');
    $dom.mainNavDropMenu = $('.header-main--drop-down-menu');
    $dom.mainNavDropLink = $('.header-main--drop-down-menu-link-list-item-link');
    $dom.mainNavDropInfoWindow = $('.header-main--drop-down-menu-link-list-item-info-window');
    $dom.mainNavDropInfoWindowImg = $('.header-main--drop-down-menu-link-list-item-info-window-img');
    $dom.mainNavDropInfoTitle = $('.header-main--drop-down-menu-link-list-item-info-window-title');
    $dom.mainNavDropInfoDescription = $('.header-main--drop-down-menu-link-list-item-info-window-description');
  };
  /*
    DESKTOP HEADER NAV DROP-DOWN
  */


  var menuShow = function menuShow(e) {
    var $activeElement = $(this);
    var childMenuName = $activeElement.attr('data-menu') || $activeElement.attr('data-menu-name');
    var $childMenu = $('#header').find("[data-menu-name='".concat(childMenuName, "']"));
    $childMenu.addClass('show');
    $(e.target).addClass('force-hold');

    if ($childMenu.is(activeMenu)) {
      clearTimeout(menuCloseTimer);
    }

    $('#header .wrapper').css('z-index', '5');
  };

  var menuHide = function menuHide(e) {
    var $activeElement = $(this);
    var childMenuName = $activeElement.attr('data-menu') || $activeElement.attr('data-menu-name');
    var $childMenu = $('#header').find("[data-menu-name='".concat(childMenuName, "']"));
    activeMenu = $childMenu;
    $('#header .wrapper').css('z-index', '');
    menuCloseTimer = setTimeout(function () {
      $childMenu.removeClass('show');
      $dom.mainNavTopLevelLink.removeClass('force-hold');
    }, hideMenuDelay);
  };
  /*
    "DUPLICATE" MOBILE TOGGLE STUFF from 'assets/main.js'...
  */


  var mobileToggleOpen = function mobileToggleOpen() {
    $('.nav_toggle').addClass('open');
    $('.nav_mobile').addClass('open');
    $('body').addClass('no-scroll');
    $(window).trigger('resize');
  };

  var mobileToggleClose = function mobileToggleClose() {
    $('.nav_toggle').removeClass('open');
    $('.nav_mobile').removeClass('open');
    $('body').removeClass('no-scroll');
    $(window).trigger('resize');
  };

  var mobileToggle = function mobileToggle() {
    $('.nav_toggle').hasClass('open') ? mobileToggleClose() : mobileToggleOpen();
  };

  var bindUIActions = function bindUIActions() {
    /*
      DESKTOP HEADER NAV DROP-DOWN
    */
    // DESKTOP NAV LINK TOGGLE
    $dom.mainNavTopLevelLink.on('mouseenter', menuShow);
    $dom.mainNavTopLevelLink.on('mouseleave', menuHide); // DESKTOP NAV DROP-DOWN MENU

    $dom.mainNavDropMenu.on('mouseenter', menuShow);
    $dom.mainNavDropMenu.on('mouseleave', menuHide);
    /*
      DESKTOP LINK HOVER IMAGE WINDOW
    */

    $dom.mainNavDropLink.on('mouseover', function (event) {
      var linkImgSrc = $(this).attr('data-link-item-img');
      var linkTitle = $(this).attr('data-link-info-item-title');
      var linkDescription = $(this).attr('data-link-info-item-description');
      var $currentMenu = $(this).parents('.header-main--drop-down-menu'); // IMG

      if (linkImgSrc != '') {
        $currentMenu.find($dom.mainNavDropInfoWindow).css('background-image', 'url(' + linkImgSrc + ')');
      } else {
        $currentMenu.find($dom.mainNavDropInfoWindow).addClass('no-img');
        $currentMenu.find($dom.mainNavDropInfoWindow).css('background-image', '');
      } // TITLE


      if (linkTitle !== '') {
        $currentMenu.find($dom.mainNavDropInfoTitle).html(linkTitle);
      } else {
        $currentMenu.find($dom.mainNavDropInfoTitle).html('');
      } // DESCRIPTION


      if (linkDescription !== '') {
        $currentMenu.find($dom.mainNavDropInfoDescription).html(linkDescription);
      } else {
        $currentMenu.find($dom.mainNavDropInfoDescription).html('');
      }
    });
    /*
      MOBILE MENU STUFF...
    */

    $('.header-mobile--menu-link').on('click', function (event) {
      var hasChildMenu = $(this).hasClass('has-child-menu'); // IF HAS CHILD MENUS, DO STUFF...

      if (hasChildMenu == true) {
        event.preventDefault();
        var childMenuName = $(this).attr('data-menu');
        var $childMenu = $('.header-mobile--sub-menus').find("[data-menu-name='".concat(childMenuName, "']"));
        $childMenu.addClass('is-active-menu');
      }
    });
    $('.header-mobile--sub-menu-back-button').on('click', function (event) {
      event.preventDefault();
      $(this).parents('.header-mobile--sub-menu').removeClass('is-active-menu');
    });
    $('.left-items .nav_toggle').on('click', function () {
      mobileToggle();
    });
  };

  function searchInit() {
    $('body').on('click', '#header .right-items .icon-search', function() {
      if($('body').hasClass('search-open')){
        $('body').removeClass('search-open');
      } else {
        $('body').addClass('search-open');
      }
    })
  }

  function adjustProductDock() {
    $(document).scroll(function() {
      if($('.top-bar').length && $('#header').hasClass('hidden')) {
        $('.hidden').addClass('top-bar-hidden');
      } else {
        $('.hidden').removeClass('top-bar-hidden');
      }
    })
  }

  var init = function init() {
    cacheDom();
    bindUIActions();
    adjustProductDock();
    // searchInit();
  };

  HeaderNavigation.init = init;
})(window.HeaderNavigation = window.HeaderNavigation || {}, jQuery);

/*!
 * ProductAddonHelpInfo.js
 */
"use strict";

(function (ProductAddonHelpInfo, $) {
  'use strict';

  var $dom = {};

  var cacheDom = function cacheDom() {
    $dom.addonHelpTrigger = $('.sw-tooltip--help-trigger');
    $dom.addonHelpPane = $('.sw-tooltip--help-pane');
    $dom.addonHelpClose = $('.sw-tooltip--help-close');
  };

  var bindUIActions = function bindUIActions() {
  
  var productForm = $('#product-display-page--content #AddToCartForm');
  $('.product-addons--group-list input.check-to-add:checkbox').change(function() {
    var addonId = $(this).closest($('form.addon-item')).find($('input:hidden[name="id"]')).val();
    var addonDesc = $(this).siblings('span.title').text().split(' ').join('-');
    var inputId = $('<input type="hidden" name="properties[' + addonDesc + ']" value=' + addonId + '>');
    productForm.prepend(inputId);
    var productTitle = $('.pdp-product--product-title').text();
    if ($(this).is(':checked')) {
      $(this).attr('value', productTitle);
      $(this).attr('name', 'properties[Add-on]');

    }
  });
  
    $dom.addonHelpTrigger.on('click', function (event) {
      $dom.addonHelpPane.removeClass('show');
      $(this).parent().find('.sw-tooltip--help-pane').addClass('show');
    });
    /*
      - CLOSE HELP PANE HIDE
    */

    $dom.addonHelpClose.on('click', function (event) {
      $dom.addonHelpPane.removeClass('show');
    });
    /*
      - PREVENT ACCORDION OPEN/CLOSE ON HELP CLICKS:
        - Using 'event.stopPropagation()' to prevent '.help-trigger' and '.help-pane'
          clicks from triggering events that toggle the accordion menu open/close.
        - see '$dom.productOptionsAccodrionHeader.on('click')' in 'scripts/ProductsOptionsAccordion.js'.
    */

    $('.sw-tooltip--help-trigger, .sw-tooltip--help-pane').on('click', function (event) {
      event.stopPropagation();
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  ProductAddonHelpInfo.init = init;
})(window.ProductAddonHelpInfo = window.ProductAddonHelpInfo || {}, jQuery);

/*!
 * ProductCalculator.js
 */
"use strict";

var _this = void 0;

(function (ProductCalculator, $) {
  'use strict';

  var _newWidth = null;
  var _newHeight = null;
  var _result = null;
  var _total = null;
  var _increment = null;
  var _measurement = null;
  var $dom = {};

  var cacheDom = function cacheDom() {
    $dom.$productCalculator = $('.sqft-calculator-mini'); // NEW SELECTOR

    $dom.win = $(window);
    $dom.openButton = $('.calc-button');
    $dom.width = $dom.$productCalculator.find('.width input');
    $dom.height = $dom.$productCalculator.find('.height input');
    $dom.result = $dom.$productCalculator.find('.result');
    $dom.endTotal = $dom.$productCalculator.find('.end-total');
    $dom.quantity = $('#AddToCartForm #quantity');
    $dom.addToCartForm = $('#AddToCartForm');
    $dom.submit = $dom.$productCalculator.find('.button');
    $dom.notice = $dom.$productCalculator.find('.notice');
    $dom.close = $dom.$productCalculator.find('.icon-close-thin');
    $dom.chat = $dom.$productCalculator.find('.chat');
    $dom.howtoToggle = $dom.$productCalculator.find('.how-to-video, .howto-modal .icon-close');
    $dom.howtoModal = $dom.$productCalculator.find('.howto-modal');
    $dom.measurementUnitSelect = $('#product-calculator--measurement-unit-select');
  };
  /*
    "DUPLICATED" METHODS
  */


  var updateWidth = function updateWidth() {
    _newWidth = $dom.width.val();
    updateCalculator();
  };

  var updateHeight = function updateHeight() {
    _newHeight = $dom.height.val();
    updateCalculator();
  };

  var updateCalculator = function updateCalculator() {
    switch (getMeasurementUnit()) {
      case 'feet':
        _result = +_newWidth / 1 * (+_newHeight / 1);
        break;

      case 'inches':
        _result = +_newWidth / 12 * (+_newHeight / 12);
        break;

      default:
        _result = +_newWidth / 12 * (+_newHeight / 12);
    }

    ;
    _result.toString().indexOf('.') != -1 && (_result = _result.toFixed(2));

    if (_result > 0) {
      $dom.result.val("".concat(_result, "'"));
    } else {
      $dom.result.val('');
    }

    updateEndTotal();
  };

  var updateEndTotal = function updateEndTotal() {
    _total = Math.ceil(_result / _increment) * _increment;
    _total > _increment * 100 ? ($dom.notice.css({
      display: 'block',
      opacity: 1
    }), $dom.notice.addClass('open'), _total = _increment * 100) : ($dom.notice.css({
      display: 'none',
      opacity: 0
    }), $dom.notice.removeClass('open'));

    if (_total > 0) {
      $('.product_add-to-cart #quantity').val(_total);
      $('.product_add-to-cart #quantity').trigger('change');
    }

    _total == 0 ? $dom.submit.removeClass('show-button') : $dom.submit.addClass('show-button');
  };

  var submit = function submit() {
    if (!$dom.submit.hasClass('show-button')) {
      return;
    }

    _this.$quantity.val(_this.total);

    _this.$addToCartForm.submit();
  };

  var close = function close() {
    $dom.$productCalculator.fadeOut();
  };
  /* END "DUPLICATED" METHODS */


  var setIncrement = function setIncrement() {
    _increment = $('#productSelect').data('increment');
  };

  var setMeasurementUnit = function setMeasurementUnit() {
    _measurement = $dom.measurementUnitSelect.val();
  };

  var getMeasurementUnit = function getMeasurementUnit() {
    return _measurement;
  };

  var unbindEvents = function unbindEvents() {
    /*
      UNBIND ALL EVENTS PREVIOUSLY SET FOR PRODUCT CALCULATOR IN 'assets/main.js'
    */
    $dom.width.off();
    $dom.height.off();
  };

  var bindUIActions = function bindUIActions() {
    /*
      CALCULATOR MINI - INPUT WIDTH
    */
    $dom.width.on('keyup', function (event) {
      $(this).val($(this).val().replace(/[^\d.]/g, ''));
      updateWidth();
    });
    /*
      CALCULATOR MINI - INPUT HEIGHT
    */

    $dom.height.on('keyup', function (event) {
      $(this).val($(this).val().replace(/[^\d.]/g, ''));
      updateHeight();
    });
    /*
      CALCULATOR MINI - INCHES or FEET
    */

    $dom.measurementUnitSelect.on('change', function (event) {
      setMeasurementUnit();
    });
    /*
      SHOW CALCULATOR MINI
    */

    $('.sqft-calculator-mini--button-toggle-show').on('click', function (event) {
      if ($('.sqft-calculator-mini').hasClass('sqft-calculator-mini--active')) {
        $(this).show();
        $('.sqft-calculator-mini').removeClass('sqft-calculator-mini--active');
      } else {
        $('.sqft-calculator-mini').addClass('sqft-calculator-mini--active');
        $(this).hide();
      }
    });
    /*
      SHOW CALCULATOR MINI - SHOW CALCULATOR MODAL
    */

    $('.sqft-calculator-mini--how-to-measure').on('click', function (event) {
      event.preventDefault();
      $('.product-calculator').removeAttr('style');
      $('.product-calculator').show();
    });
    $('.sqft-calculator-mini--measurement-unit-select').on('change', function (event) {
      event.preventDefault();
      var mesurement = $(this).val();

      switch (mesurement) {
        case 'feet':
          $('[for=sqft-calculator-mini--input-width]').text('Width (ft)');
          $('[for=sqft-calculator-mini--input-height]').text('Height (ft)');
          break;

        case 'inches':
          $('[for=sqft-calculator-mini--input-width]').text('Width (in)');
          $('[for=sqft-calculator-mini--input-height]').text('Height (in)');
          break;

        default:
          $('[for=sqft-calculator-mini--input-width]').text('Width (in)');
          $('[for=sqft-calculator-mini--input-height]').text('Height (in)');
      }

      ;
      updateCalculator();
    });
  };

  var init = function init() {
    cacheDom();
    setIncrement();
    setMeasurementUnit();
    unbindEvents();
    bindUIActions();
    updateCalculator();
  };

  ProductCalculator.init = init;
})(window.ProductCalculator = window.ProductCalculator || {}, jQuery);

/*!
 * ProductOptionsSubTotal.js
 */
"use strict";

(function (ProductOptionsSubTotal, $) {
  'use strict';

  var $dom = {};

  var cacheDom = function cacheDom() {
    // PRODUCT SUB-TOTAL
    $dom.productOptionsSubTotals = $('.product-options-sub-totals'); // PRODUCT SUB-TOTAL - STANDARD (PAY ONCE)

    $dom.productOptionsSubTotal__standard = $('.product-options-sub-totals--method-standard');
    $dom.productOptionsSubTotal__standard_value = $dom.productOptionsSubTotal__standard.find('.product-options-sub-totals--method-sub-total--value'); // PRODUCT SUB-TOTAL - AFFIRM (MONTHLY PAYMENTS)

    $dom.productOptionsSubTotal__affirm = $('.product-options-sub-totals--method-affirm');
    $dom.productOptionsSubTotal__affirm_value = $('.product-options-sub-totals--method-affirm').find('.product-options-sub-totals--method-sub-total--value'); // PRODUCT QUANTITY SELECT

    $dom.productOptionsVariantQuantitySelect = $('#quantity'); // ADD-ONS (CHECKBOX)

    $dom.productOptionsAddOnItems = $('.addon-item');
    $dom.productOptionsAddOnItemsCheckbox = $dom.productOptionsAddOnItems.find('input[type="checkbox"]');
  };

  var toDollars = function toDollars(cents) {
    return (cents / 100.0).toFixed(2);
  };

  var setUpadtedProductVariantPrice = function setUpadtedProductVariantPrice(priceCents) {
    $dom.productOptionsSubTotal__standard_value.text(toDollars(priceCents));
  };

  var getProductOptionsSelectedQuantityNumber = function getProductOptionsSelectedQuantityNumber() {
    return parseInt($dom.productOptionsVariantQuantitySelect.val(), 10);
  };

  var getUpadtedProductVariantPrice = function getUpadtedProductVariantPrice(quantity) {
    var selectedQuantity = getProductOptionsSelectedQuantityNumber();
    var variantPrice = parseInt($dom.productOptionsSubTotals.attr('data-variant-price'), 10);
    var updatedPrice = variantPrice * selectedQuantity;
    return updatedPrice;
  };

  var setUpadtedProductSubTotal = function setUpadtedProductSubTotal() {
    var udpatedProductVariantPrice = getUpadtedProductVariantPrice();
    var updatedAddOnItemsPrice = getProductOptionsAddOnItemsPrice();
    var newSubTotal = setUpadtedProductVariantPrice(udpatedProductVariantPrice + updatedAddOnItemsPrice);
    $dom.productOptionsSubTotal__standard_value.attr('data-price-sub-total', udpatedProductVariantPrice + updatedAddOnItemsPrice);
    $dom.productOptionsSubTotal__standard_value.text(newSubTotal);
  };
  /*
    PRODUCT ADD-ONS
  */


  var getProductOptionsAddOnItemsPrice = function getProductOptionsAddOnItemsPrice() {
    var combinedAddOnItemsBasePrice = 0;
    var selectedQuantity = getProductOptionsSelectedQuantityNumber();
    $dom.productOptionsAddOnItemsCheckbox.each(function (index, addOnItemCheckbox) {
      if ($(addOnItemCheckbox).is(':checked')) {
        var $addOnItem = $(addOnItemCheckbox).parents('.addon-item');
        var addOnItemBasePrice = parseInt($addOnItem.find('.price-info').attr('data-addon-item-price'), 10); // IF ADD-ON ITEM IS CHECKED, GET ADD-ON ITEM PRICE and ADD to variable 'combinedAddOnItemsBasePrice'

        combinedAddOnItemsBasePrice += addOnItemBasePrice;
      }
    }); // Get final add-on price by multiplying the selected product quantity.

    var combinedAddOnItemsPrice = combinedAddOnItemsBasePrice * selectedQuantity;
    return combinedAddOnItemsPrice;
  };
  /*
     UPDATE AFFIRM PRICE
   */


  var updateAffirmPrice = function updateAffirmPrice() {
    var priceSubTotal = $('.product-options-sub-totals--method-sub-total--value').attr('data-price-sub-total');
    $('.affirm-as-low-as').attr('data-amount', priceSubTotal);
    affirm.ui.refresh();
  };

  var bindUIActions = function bindUIActions() {
    /*
      QUANTITY SELECT
    */
    $dom.productOptionsVariantQuantitySelect.on('change', function (event) {
      setUpadtedProductSubTotal();
      updateAffirmPrice();
    });
    $('.products_docked-nav .select-wrap select').on('change', function (event) {
      $dom.productOptionsVariantQuantitySelect.trigger('change');
    });
    /*
      ADD-ONS
    */

    $dom.productOptionsAddOnItemsCheckbox.on('change', function (event) {
      setUpadtedProductSubTotal();
      updateAffirmPrice();
    });
    $(window).load(function () {
      updateAffirmPrice();
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  ProductOptionsSubTotal.init = init;
})(window.ProductOptionsSubTotal = window.ProductOptionsSubTotal || {}, jQuery);

/*!
 * ProductsMediaSlider.js
 */
"use strict";

(function (ProductsMediaSlider, $) {
  'use strict';

  var $dom = {};
  var productVimeoPlayersArray = [];
  var LAST_PLAYER_INDEX = 0;
  var CURRENT_PLAYER_INDEX = 0;

  var cacheDom = function cacheDom() {
    $dom.pdpProductMediaSlider = $('.pdp-product-media-slider');
    $dom.pdpProductMediaThumbnailsSlider = $('.pdp-product-media-thumbnails-slider');
    $dom.mediaVimeoIframes = $('.pdp-product-media-slider .slide--video iframe');
  };

  var setVimeoPlayers = function setVimeoPlayers(iframes) {
    /*
      - instantiate new players for each iframe to control videos with JS.
      - Store Vimeo Players in an Array with matching indexes as iframe selector for later use.
    */
    iframes.each(function (index, iframe) {
      var player = new VimeoPlayer(iframe);
      productVimeoPlayersArray.push(player);
    });
  };

  var getVimeoPlayer = function getVimeoPlayer(index) {
    return productVimeoPlayersArray[index];
  }; // VIMEO PLAYER - PLAY VIDEO


  var vimeoPlayerInit = function vimeoPlayerInit() {
    setVimeoPlayers($dom.mediaVimeoIframes);
  }; // VIMEO PLAYER - PLAY VIDEO


  var vimeoPlayerPlay = function vimeoPlayerPlay(vimeoPlayer) {
    vimeoPlayer.play();
  }; // VIMEO PLAYER - PAUSE VIDEO


  var vimeoPlayerPause = function vimeoPlayerPause(vimeoPlayer) {
    vimeoPlayer.pause();
  };

  var bindUIActions = function bindUIActions() {
    // MEDIA SLIDER
    $dom.pdpProductMediaSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      draggable: false,
      swipeToSlide: false,
      swipe: false,
      touchMove: false,
      infinite: false
    }); // MEDIA SLIDER THUMBNAILS

    $dom.pdpProductMediaThumbnailsSlider.slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      focusOnSelect: true,
      asNavFor: $dom.pdpProductMediaSlider,
      draggable: false,
      touchMove: false,
      prevArrow: '<button type="button" class="slick-prev is-disabled">Previous</button>',
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      }]
    });
    /*
      ON AFTER SLIDE CHANGE:
      1. Trigger video play on video slides change, and pause previous video slide if applicable.
      2. Since 'asNavFor' config setting is not set to the thumbnails slider, so must update active thumbnail when slick event is triggered.
    */

    $dom.pdpProductMediaSlider.on('afterChange', function (slick, currentSlide, slideIndex) {
      CURRENT_PLAYER_INDEX = slideIndex;
      var thumbsSlider = $dom.pdpProductMediaThumbnailsSlider.slick('getSlick');
      var thumbsSliderNextSlide = thumbsSlider.$slides.eq(CURRENT_PLAYER_INDEX);
      var $mainSlider = $dom.pdpProductMediaSlider.slick('getSlick');
      var $mainSliderNextSlide = $mainSlider.$slides.eq(CURRENT_PLAYER_INDEX);
      var $mainSliderPrevSlide = $mainSlider.$slides.eq(LAST_PLAYER_INDEX);
      var iframeNextIndex = $mainSliderNextSlide.find('iframe').index('iframe');
      var iframePrevIndex = $mainSliderPrevSlide.find('iframe').index('iframe');
      var currentPlayer = productVimeoPlayersArray[iframeNextIndex];
      var lastPlayer = productVimeoPlayersArray[iframePrevIndex]; // 1. PLAY / PAUSE VIDEO SLIDES ON SLIDE CHANGE

      if (CURRENT_PLAYER_INDEX !== LAST_PLAYER_INDEX) {
        if (typeof lastPlayer !== 'undefined') {
          vimeoPlayerPause(lastPlayer);
        }

        if (typeof currentPlayer !== 'undefined') {
          vimeoPlayerPlay(currentPlayer);
        }
      }
    });
    /*
      SLICK SLIDER EVENT:
        - Track slides to play/pause videos
        - Used with 'afterChange' slick event
    */

    $dom.pdpProductMediaSlider.on('beforeChange', function (slick, currentSlide, slideIndex) {
      var eventCurrentSlide = $(this).slick('slickCurrentSlide');
      LAST_PLAYER_INDEX = slideIndex;
    });
    /*
      THUMBNAILS - ON AFTER SLIDE CHANGE:
      1. Add custom class to disable buttons visually,
      since Slick adds disable class based on amount of slides able to page
      instead of based on current slide.
    */

    $dom.pdpProductMediaThumbnailsSlider.on('afterChange', function (slick, currentSlide, slideIndex) {
      var currentSlideIndex = slideIndex + 1;
      var thumbSlick = $(this).slick('getSlick');
      var thumbSlickSlideCount = thumbSlick.slideCount;

      if (currentSlideIndex == 1) {
        $(this).find('.slick-prev').addClass('is-disabled');
      } else {
        $(this).find('.slick-prev').removeClass('is-disabled');
      }

      if (currentSlideIndex == thumbSlickSlideCount) {
        $(this).find('.slick-next').addClass('is-disabled');
      } else {
        $(this).find('.slick-next').removeClass('is-disabled');
      }
    });
  };

  var init = function init() {
    cacheDom();
    vimeoPlayerInit();
    bindUIActions();
  };

  ProductsMediaSlider.init = init;
})(window.ProductsMediaSlider = window.ProductsMediaSlider || {}, jQuery);

/*!
 * ProductsOptionsAccordion.js
 */
"use strict";

(function (ProductsOptionsAccordion, $) {
  'use strict';

  var $dom = {};

  var cacheDom = function cacheDom() {
    $dom.productOptionsAccodrionHeader = $('.product_options--accordion-header');
    $dom.productOptionsAccodrionContent = $('.product_options--accordion-content');
  };

  var bindUIActions = function bindUIActions() {
    var accordionTopLevelClass = '.product_options--accordion';
    var accordionActiveClassName = 'js-option-accordion-open';
    $dom.productOptionsAccodrionHeader.on('click', function (event) {
      var $accordionTopLevel = $(this).parents(accordionTopLevelClass);
      $accordionTopLevel.hasClass(accordionActiveClassName) ? $accordionTopLevel.removeClass(accordionActiveClassName) : $accordionTopLevel.addClass(accordionActiveClassName);
    });
  };

  var init = function init() {
    cacheDom();
    bindUIActions();
  };

  ProductsOptionsAccordion.init = init;
})(window.ProductsOptionsAccordion = window.ProductsOptionsAccordion || {}, jQuery);

/*!
 * Cart.js
 */
(function (CartQuantity, $) {
  'use strict';

  function adjustAddonQty () {
    var isAddon = $(this).closest('.cart__row').data('is-addon');
    //if the element clicked is the main product item
    if(!isAddon) {
      var mainProductQty = $(this).siblings('.number').text(),
          mainProductTitle = $(this).parent().siblings('.cart_item-title').find('.product-title').text().trim(),
          doAddonsExist = $('.cart__row[data-is-addon="true"]').length,
          allAddons = $('.cart__row[data-is-addon="true"]');
      if(doAddonsExist) {
        allAddons.filter(function(i,e) {
          if($(this).data('item-type') === mainProductTitle) {
            $(this).find('.cart_item-quantity .number').text(mainProductQty);
            $(this).find('.cart_item-quantity input.quantity').attr('value', Number(mainProductQty));
            $(this).find('.cart_item-quantity input.quantity').val(Number(mainProductQty));
          }
        })
      }
    }
  }

  function successCallback() {
    var allProductRows = $('.cart-table .cart__row.cart_item-row.table__section');

    $('.loading-gif').hide();

    //recalculate all product line item position
    allProductRows.each(function(i){
      $(this).attr('data-line-item', i);
    })
  }

  function removeItem(e) {
    var productRow = $(this).closest('.cart__row');
    var lineItemPosition = productRow.data('line-item');
    var isMainProduct = (productRow.attr('data-ismainproduct') === 'true') ? true : false;

    var productTitle = productRow.attr('data-item-type');
    var mainProductAndAddons = $('.cart__row[data-item-type="' + productTitle + '"]');
    var updatedCartData = [];
    var totalCartItemCount;

    $('.loading-gif').css('display', 'flex');

    $.getJSON('/cart.js', function(cartData) {
      $(cartData.items).each(function() {
        updatedCartData.push(this.quantity);
      })
    }).done(function(cartData) {
      if(isMainProduct) {
        if(mainProductAndAddons.length > 1) {
          //do this if addons exist
          mainProductAndAddons.each(function() {
            var currentLineItem = $(this).attr('data-line-item');
            updatedCartData[currentLineItem] = 0;
            $(this).remove();
          })
        } else {
          //do this if only the main product exists
          updatedCartData[lineItemPosition] = 0;
          productRow.remove();
        }
      } else {
        updatedCartData[lineItemPosition] = 0;
        productRow.remove();
      }

      $.post('/cart/update.js', {updates: updatedCartData}, successCallback, 'json');

      totalCartItemCount = $('.cart__row.cart_item-row.table__section').length;

      $('#nav_customer .wrap  a').text('Cart (' + totalCartItemCount + ')');
      $('#header .right-items .mobile-top-nav--cart-count').text(totalCartItemCount);
      $('#main .icon-stik-tree~.count').text('(' + totalCartItemCount + ')');

    })
  }


  var init = function init() {
    $('body').on('click', '.quantity-controls', adjustAddonQty)
    $('body').on('click', '.icon-close', removeItem)
  };

  CartQuantity.init = init;
})(window.CartQuantity = window.CartQuantity || {}, jQuery);

/*!
 * Newsletter.js
 */
(function (Newsletter, $) {
  'use strict';
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('newsletter') && (urlParams.get('newsletter') === 'success')) {
    $("#email_signup").hide();
    $("#newsletter_title").html("Thank you!");
    $("#newsletter_subtitle").html("You'll be hearing from us soon.");
  }
})(window.Newsletter = window.Newsletter || {}, jQuery);